import { createI18n } from 'vue-i18n' 
// 从本地存储获取用户语言偏好
const savedLanguage = localStorage.getItem('userLanguage') ||
  (navigator.language.startsWith('zh') ? 'zh' : 'en')

// 创建i18n实例
const i18n = createI18n({
  legacy: false, // 必须设置为 false（Vue 3 模式）
  locale: savedLanguage, // 默认语言
  fallbackLocale: 'zh', // 回退语言
  globalInjection: true, // 启用全局 $t 方法
  messages: {} // 可以留空，由 <i18n> 块或文件导入提供
}) 
export default i18n